export const bindAction = (ref, bimRef) => {
    const viewer = bimRef.current;
    if (!viewer) {
        throw new Error('找不到 bimRef');
    }
    let isRotate = false;
    let isZoom = false;
    let isColor = false;
    let isBlink = false;
    let customItemContainer;
    const actionTyping = {
        onStartAutoRotate: (step) => {
            if (isRotate) {
                viewer?.stopAutoRotate();
                viewer?.render();
                isRotate = false;
                return;
            }
            isRotate = !isRotate;
            viewer?.startAutoRotate(step);
        },
        onStopAutoRotate: () => {
            viewer?.stopAutoRotate();
        },
        onZoomTo: (elementId) => {
            if (isZoom) {
                viewer.setView(Glodon.Bimface.Viewer.ViewOption.Home);
                isZoom = false;
                return;
            }
            viewer.clearSelectedComponents();
            viewer.addSelectedComponentsById(elementId);
            viewer.zoomToSelectedComponents();
            isZoom = true;
        },
        onColorTo: (elementId, _color) => {
            if (isColor) {
                viewer.clearOverrideColorComponents();
                viewer.render();
                isColor = false;
                return;
            }
            const color = new Glodon.Web.Graphics.Color(_color, 0.6);
            viewer.overrideComponentsColorById(elementId, color);
            viewer.render();
            isColor = true;
        },
        onOverrideComponentsColorByObjectData: (conditions, _color, boundingBox) => {
            if (boundingBox) {
                viewer.zoomToBoundingBox(boundingBox);
            }
            const color = new Glodon.Web.Graphics.Color(_color, 0.6);
            viewer.overrideComponentsColorByObjectData(conditions, color);
            viewer.render();
            isColor = true;
        },
        onClearColors: () => {
            viewer.clearOverrideColorComponents();
            viewer.render();
        },
        onClearBlink: () => {
            viewer.clearAllBlinkComponents();
            viewer.render();
        },
        onBlink: (elementId, time, _color) => {
            if (isBlink) {
                viewer.onClearBlink();
                isBlink = false;
                return;
            }
            const color = new Glodon.Web.Graphics.Color(_color, 0.8);
            viewer.enableBlinkComponents(true);
            viewer.addBlinkComponentsById(elementId);
            viewer.setBlinkColor(color);
            viewer.setBlinkIntervalTime(500);
            viewer.render();
            isBlink = true;
            setTimeout(() => {
                viewer.onClearBlink();
                isBlink = false;
            }, time);
        },
        onGetComponentsByConditions: (conditions) => {
            return new Promise(async (resolve, reject) => {
                // conditions判空
                const newConditions = conditions?.map((cur) => {
                    const filterItem = {};
                    const keys = Object.keys(cur);
                    if (keys.length > 0) {
                        keys?.forEach((cKey) => {
                            if (cur[cKey] || cur[cKey] === 0) {
                                filterItem[cKey] = cur[cKey];
                            }
                        });
                    }
                    return filterItem;
                });
                // 文档将会弃用
                // viewer?.getModel()?.getComponentsByConditions(
                //   newConditions?.map((item: any) => ({
                //     ...item,
                //     fileId: item?.fileId?.toString(),
                //   })),
                //   resolve,
                //   reject,
                // );
                const ids = viewer?.getModel()?.getMatchIds(newConditions);
                // console.log('ids', ids);
                resolve(ids || []);
            });
        },
        onGetComponentProperty: (id, { cid, type }) => {
            return new Promise((resolve, reject) => {
                viewer?.getModel()?.getComponentProperty(id, (result) => {
                    if (type === 'levelName') {
                        type = 'floor';
                    }
                    if (type === 'categoryId') {
                        type = 'categoryName';
                    }
                    if (!type) {
                        type = 'last';
                    }
                    const items = result?.properties?.[0]?.items;
                    const keys = [
                        'floor',
                        'categoryName',
                        'family',
                        'familyType',
                        'last',
                    ];
                    const keyIndex = keys.findIndex((key) => key === type) + 1;
                    const names = keys.slice(0, keyIndex).map((key) => {
                        if (key === 'last') {
                            return `${items.find(({ key: _key }) => _key === 'family')?.value}[${cid}]`;
                        }
                        return items.find(({ key: _key }) => key === _key)?.value;
                    });
                    resolve({ names, ...result });
                }, reject);
            });
        },
        onIsolateComponentsById: (ids, type) => {
            if (type) {
                viewer
                    ?.getModel()
                    ?.isolateComponentsById(ids, type === 'hide'
                    ? Glodon.Bimface.Viewer.IsolateOption.HideOthers
                    : Glodon.Bimface.Viewer.IsolateOption.MakeOthersTranslucent);
            }
        },
        onIsolateComponentsByObjectData: (conditions, type) => {
            if (type) {
                viewer
                    ?.getModel()
                    ?.isolateComponentsByObjectData(conditions, type === 'hide'
                    ? Glodon.Bimface.Viewer.IsolateOption.HideOthers
                    : Glodon.Bimface.Viewer.IsolateOption.MakeOthersTranslucent);
            }
        },
        onGetBoundingBoxById: (id) => viewer?.getModel()?.getBoundingBoxById(id),
        onHideAllComponents: () => {
            viewer?.getModel()?.hideAllComponents();
        },
        onShowComponentsByObjectData: (conditions) => {
            viewer?.getModel()?.showComponentsByObjectData(conditions);
        },
        onShowAllComponents: () => {
            viewer?.getModel()?.showAllComponents();
        },
        onCustomTags: (customTags) => {
            if (!customItemContainer) {
                const drawableContainerConfig = new Glodon.Bimface.Plugins.Drawable.DrawableContainerConfig();
                drawableContainerConfig.viewer = viewer;
                drawableContainerConfig.maxNum = 50;
                customItemContainer =
                    new Glodon.Bimface.Plugins.Drawable.DrawableContainer(drawableContainerConfig);
            }
            if (customItemContainer?.getAllItems()?.length) {
                customItemContainer?.clear();
            }
            let config;
            const tags = customTags?.map(({ boundingBox, tagConfig: { content: propsContent, onClick, props }, }) => {
                config = new Glodon.Bimface.Plugins.Drawable.CustomItemConfig();
                const content = document.createElement('div');
                content.innerHTML = propsContent;
                config.content = content;
                config.viewer = bimRef.current;
                config.worldPosition = boundingBox?.max;
                const customItem = new Glodon.Bimface.Plugins.Drawable.CustomItem(config);
                customItem.onClick(() => {
                    onClick(props);
                });
                return customItem;
            });
            customItemContainer?.addItems(tags);
        },
    };
    ref.current = actionTyping;
};
